import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    body: {
      border: `1px solid ${theme.colors.blue[1]}`,
      backgroundColor: '#fff',
      [theme.fn.largerThan('sm')]: {
        '.due-date-card': {
          '.mantine-HealthToolFormWrapper-root': {
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
        '.mantine-HealthToolFormWrapper__FormRow-root': {
          paddingLeft: 40,
          paddingRight: 40,
        },
        '.mantine-HealthToolFormWrapper-root': {
          paddingTop: 40,
          paddingBottom: 24,
          '&.baby-growth-card': {
            paddingTop: 0,
            paddingBottom: 0,
            '.mantine-HealthToolFormWrapper__FormRow-root': {
              paddingLeft: 0,
              paddingRight: 0,
            },
          },
          '&.bmi-card-wrapper': {
            paddingBottom: 0,
            '.mantine-BmiForm-newsletterBlock': {
              paddingBottom: 24,
            },
          },
        },
        '.baby-poop-card': {
          paddingTop: 24,
          paddingBottom: 8,
          button: {
            marginTop: 8,
          },
        },
      },
      [theme.fn.smallerThan('sm')]: {
        '&:before': {
          content: 'none',
        },
        '.form-wrapper': {
          padding: 0,
        },
        '&>:not(style)': {
          position: 'static',
        },
        '.mantine-HealthToolFormWrapper-root': {
          paddingTop: 16,
          paddingBottom: 16,
          '&.baby-growth-card': {
            paddingTop: 0,
            paddingBottom: 0,
            '.mantine-HealthToolFormWrapper__FormRow-root': {
              paddingLeft: 0,
              paddingRight: 0,
            },
          },
        },
        '.mantine-HealthToolFormWrapper__FormRow-root': {
          '&:last-child': {
            paddingBottom: 0,
          },
        },
        '.mantine-BmiForm-newsletterBlock': {
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
        },
        '.baby-poop-card': {
          paddingBottom: 16,
        },
        '.due-date-card': {
          '.mantine-HealthToolFormWrapper-root': {
            paddingTop: 0,
            paddingBottom: 0,
          },
        },
      },
    },
    bodyInner: {},
    healthForm: {
      display: 'flex',
      flexDirection: 'column',
      gap: rem(16),
      padding: rem(16),
      [theme.fn.largerThan('sm')]: {
        padding: rem(32),
        gap: rem(24),
      },
    },
  }
})
